module.exports = __webpack_public_path__ + "img/step20_a_stand_power_install_and_fix_left_adaptor.997936e5.png";